<template>
<div id="faq">
  <div class="center">
    <h4 class="cyan-text text-darken-1">よくある問い合わせ</h4>
    <p>現在、問い合わせはないですが、</p>
    <p>質問が増えてきたら更新していきます。</p>
    <p><質問先はツイッターからDMください></p>
    <p><a href="https://twitter.com/katonobo1">ツイッター</a></p>
  </div>
</div>
</template>

<script>
export default {
  name: 'Faq',
  data(){
    return{

    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/info/Faq.vue